import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { isEmpty } from "lodash";

@Component({
	selector: "app-cbta-avatar",
	templateUrl: "./cbta-avatar.component.html",
	styleUrls: ["./cbta-avatar.component.scss"],
	standalone: false,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CbtaAvatarComponent implements OnInit, OnChanges {
	@Input() imageUrl?: string;
	@Input() hasBorder?: boolean = false;
	@Input() radius?: "full" | "md" | "lg" | "xl" | "full" | "none" = "full";
	@Input() size: number = 30;
	@Input() name: string = "CBTA";

	imageError = false;

	// private colors: string[] = [
	//   '#00AA55', '#009FD4', '#B381B3', '#939393', '#E3BC00',
	//   '#D47500', '#DC2A2A', '#1abc9c', '#2ecc71', '#3498db',
	//   '#9b59b6', '#34495e', '#f1c40f', '#e67e22', '#e74c3c',
	//   '#95a5a6', '#16a085', '#27ae60', '#2980b9', '#8e44ad',
	//   '#2c3e50', '#f39c12', '#d35400', '#c0392b', '#bdc3c7',
	//   '#7f8c8d', '#e74c3c'
	// ];

	constructor() {}

	ngOnInit(): void {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes["imageUrl"]) {
			this.imageError = false;
		}
	}

	onImageError(): void {
		this.imageError = true;
	}

	get hasImage(): boolean {
		return !isEmpty(this.imageUrl) && !this.imageError;
	}

	// generateAvatarColor(name: string): string {

	//   const charCodes = name
	//     .split('')
	//     .map(char => char.charCodeAt(0)) // => [65, 65]
	//     .join('');

	//   return this.colors[parseInt(charCodes) % this.colors.length]

	// }

	get initial(): string {
		return this.name.charAt(0).toUpperCase();
	}
}
